
import { Component } from 'react';
import { makeBEM, getDateProp, formatDateForTasks, convertDatePickerValueToLocal } from '../global/utils';
import { LABELS } from '../global/constants';
import Icon from '../atoms/Icon' ;
import { GeneralObserver } from './Observer';

export default class TasksModule extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            controller: this.props.controller ? this.props.controller : false,
            boardID: this.props.boardID,
            tasks: [],
            view: 'day',
        };

        this.observer = false;
        this.moduleName = 'tasks';
        this.bindFunctions();
    }

    // Binds functions to instance
    bindFunctions() {
        this.dateChange = this.dateChange.bind(this);
        this.goToPrevDate = this.goToPrevDate.bind(this);
        this.goToToday = this.goToToday.bind(this);
        this.goToNextDate = this.goToNextDate.bind(this);
        this.reactFn = this.reactFn.bind(this);
    }

    componentDidMount() {
        this.initialSetup();
    }

    // Setup observer and subscribe to events from controller
    // Fetch data from controller 
    initialSetup() {
        const ctrl = this.state.controller;
        this.observer = new GeneralObserver(this.reactFn);

        ctrl.addObserver(this.observer);
        ctrl.fetchTasks();

        this.setState({
            controller: ctrl
        });
    }

    // Updates tasks data from controller when controller's Observer notifies subject 
    reactFn() {
        const ctrl = this.state.controller;
        const newData = ctrl.getTasks();
        
        this.setState({
            controller: ctrl,
            tasks: newData,
        });
    }

    // Called when dateChange event is triggered by the date picker
    // Converts date picker date
    // Calls controller goToDate function 
    dateChange(e) {
        const { value } = e.target;
        const targetDate = convertDatePickerValueToLocal(value);

        if ( value ) {
            const ctrl = this.state.controller;

            ctrl.goToDate(targetDate);
            this.setState({
                currentDate: ctrl.getCurrentDate(),
            });
        }
    }

    // Retreats currentDate by one, controller retrieves tasks for new date
    goToPrevDate(e) {
        const ctrl = this.state.controller;
        ctrl.goToPrevDate();
    }

    // Sets currentDate to today, controller retrieves tasks for today
    goToToday(e) {
        const ctrl = this.state.controller;
        ctrl.goToToday();
    }
    
    // Advances currentDate by one, controller retrieves tasks for new date
    goToNextDate(e) {
        const ctrl = this.state.controller;
        ctrl.goToNextDate();
    }

    // Renders dummy content while reloading
    renderDummyContent() {
        return (
            <div>
                <div class="tasks__date-picker-wrapper dummy">
                    <div className="tasks__target-date shimmer"></div>
                    <div className="tasks__date-picker-btns shimmer"></div>
                </div>
                <div className="tasks__wrapper"> 
                    <div class="tasks__task task dummy">
                        <p class="task__content shimmer"></p>
                        <div class="task__dates-wrapper">
                            <div class="date start-date task__start-date shimmer"></div>
                            <div class="date end-date task__end-date shimmer"></div>
                        </div>
                    </div>
                    
                    <div class="tasks__task task dummy">
                        <p class="task__content shimmer"></p>
                        <div class="task__dates-wrapper">
                            <div class="date start-date task__start-date shimmer"></div>
                            <div class="date end-date task__end-date shimmer"></div>
                        </div>
                    </div>

                    <div class="tasks__task task dummy">
                        <p class="task__content shimmer"></p>
                        <div class="task__dates-wrapper">
                            <div class="date start-date task__start-date shimmer"></div>
                            <div class="date end-date task__end-date shimmer"></div>
                        </div>
                    </div>

                </div>
            </div>
        )
    }

    // Renders a task object
    renderTask(task) {
        const type = task.getObjectType();
        const modifierClass = `task--${type.toLowerCase()}`
        const className = `${makeBEM(this.moduleName, 'task')} task ${modifierClass}`
        const startDate = task.getStartDate();
        const startDateTime = startDate ? getDateProp(startDate, "time") : '';

        const endDate = task.getEndDate();
        const endDateTime = endDate ?  getDateProp(endDate, "time") : '';
        const divider = startDate && endDate ? '-' : '';

        return (
            <div className={className} key={task.getId()} >
                <p className={ makeBEM('task', 'content') }> { task.getContent() } </p>
                <div className={ makeBEM('task', 'dates-wrapper') }>
                    { startDate &&
                        <div className={ `date start-date ${makeBEM('task', 'start-date')}` }> {startDateTime} </div>
                    }
                    {
                        endDate &&
                        <div className={ `date end-date ${makeBEM('task', 'end-date')}` }> {  divider } {endDateTime} </div>
                    }
                </div>
            </div>
        );
    }

    // Renders tasks
    render() {
        const ctrl = this.state.controller;
        if ( !ctrl ) {
			return false;
		}

        const reloading = this.props.reloading;
		const renderContent = !reloading;

        const tasks = ctrl.getTasks();
        const currentDate = ctrl.getCurrentDate();
        const currentDateValue = getDateProp(currentDate, 'date');
        const currentDateStr = formatDateForTasks(currentDate);
        const hasTasks = tasks && tasks.length > 0;
        const todayBtnDisabled = ctrl.currentDateIsToday();

        if ( reloading ) {
            return ( 
                <div className={this.moduleName}>
                    { this.renderDummyContent() }
                </div>
            )
        }
        if ( tasks && renderContent ) {
            return (
                <div className={this.moduleName}>
                    <div className={makeBEM(this.moduleName, 'date-picker-wrapper')}>
                        <input 
                                className={makeBEM(this.moduleName, 'target-date')}
                                type="date" 
                                name="target_date" 
                                value={currentDateValue}
                                onChange={this.dateChange}
                        />
                        <div className={makeBEM(this.moduleName, 'date-picker-btns')}>
                            <button 
                                className={ `btn btn--icon btn--molding ${makeBEM(this.moduleName, 'prev-btn')}` }
                                onClick={this.goToPrevDate}
                            >
                                <Icon name="chevron-left" />
                            </button>
                            <button 
                                className={ `btn btn--text btn--molding ${makeBEM(this.moduleName, 'today-btn')}` }
                                onClick={this.goToToday}
                                disabled={todayBtnDisabled}
                            >
                                {LABELS.today}
                            </button>
                            <button 
                                className={ `btn btn--icon btn--molding ${makeBEM(this.moduleName, 'next-btn')}` }
                                onClick={this.goToNextDate}
                            >
                                <Icon name="chevron-right" />
                            </button>
                        </div>
                    </div>
                    
                    <div className={ makeBEM(this.moduleName, 'wrapper') }>
                        <p className={ `${makeBEM(this.moduleName, 'current-date')}` }> { currentDateStr} </p>
                        {
                            hasTasks && renderContent ?
                            Object.keys(tasks).map(key => (
                                this.renderTask(tasks[key])
                            ))
                            : 
                            ( <p className={ `${makeBEM(this.moduleName, 'no-tasks-label')}` }> {LABELS.noTasksForThisDay} </p> )
                        }
                    </div>

                </div>
            );
        }
        return '';
    }

}